// extracted by mini-css-extract-plugin
export default {"skillContainer":"SkillIcon_skillContainer__Mk9Gf"};